import { isNumberString } from "cy-util";
import { FieldErrors, FieldValues } from "react-hook-form";

export type ValidationResult = string | string[] | boolean | undefined;

export const validationMessages: any = {
  required: "Required",
  min: "Min Value $arg1",
  max: "Max Value $arg1",
  minLength: "Min Length $arg1",
  maxLength: "Max Length $arg1",
  email: "Invalid Email",
  general: "Invalid Value",
};

export function parseErrorMessage(
  errors: FieldErrors<FieldValues>,
  key: string,
  arg: any = ""
): string {
  const error = errors[key];
  if (!error) {
    return "";
  }
  let message =
    error?.message ||
    (error?.type && validationMessages[error?.type as any]) ||
    "";
  message = message.replace("$arg1", arg || "");
  return message || "Invalid Value";
}

export function isNumberValidator(
  value: string,
  msg = "Number Required"
): ValidationResult {
  if (value === "") {
    return;
  }

  return isNumberString(value) ? undefined : msg;
}
